import { EmergencyInfo } from './EmergencyInfo';
import { AdditionalInfo } from './AdditionalInfo';
import styles from './ContactData.module.css';
import { ErrorBoundaryProvider } from '../../../../../providers/ErrorBoundaryProvider';

export const ContactData = () => {
	return (
		<ErrorBoundaryProvider>
			<div className={styles.contact_data_container}>
				<AdditionalInfo />
				<hr className={styles.horizontal_line} />
				<EmergencyInfo />
			</div>
		</ErrorBoundaryProvider>
	);
};
ContactData.displayName = 'CheckBoxInfo';
